import React from 'react'
import ReactDOM from 'react-dom'
import classNames from 'classnames'

type Props = React.HTMLAttributes<HTMLElement> &
    React.PropsWithChildren<{
        open: boolean
        size?: 'small' | 'medium' | 'large' | 'auto'
        onClose: () => void
    }>

export function ModalBottomSheet({ open, size, onClose, children, ...attr }: Props) {
    return ReactDOM.createPortal(
        <aside
            {...attr}
            role="dialog"
            className={classNames('AppCore__ui__ModalBottomSheet', {
                'AppCore__ui__ModalBottomSheet--IsOpen': open,
            })}
        >
            <div className="AppCore__ui__ModalBottomSheet__Backdrop" onClick={onClose}></div>
            <div
                className={classNames('AppCore__ui__ModalBottomSheet__Content', {
                    'AppCore__ui__ModalBottomSheet__Content--IsSmall': size === 'small',
                    'AppCore__ui__ModalBottomSheet__Content--IsMedium': size === 'medium' || !size,
                    'AppCore__ui__ModalBottomSheet__Content--IsLarge': size === 'large',
                    'AppCore__ui__ModalBottomSheet__Content--IsAuto': size === 'auto',
                })}
            >
                {children}
            </div>
        </aside>,
        document.body
    )
}
